import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import { ErrorMessage, Field, Formik, Form } from 'formik';
import CustomSelect from '../../common/formElements/CustomSelect';
import CustomLoader from '../common/CustomLoader';
import { XANO } from 'drapcode-constant';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class XanoDatabaseList extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    selectedOption: null,
    selectError: '',
  };

  handleApi = async (id) => {
    const { projectId, version } = this.props.match.params;
    const { xanoData, xanoCustomName } = this.props.location.state;
    const { actions, history, dataConnector } = this.props;
    const { token } = history.location.state;

    try {
      await actions.getXanoTable({ token, projectId, id, version });
      if (xanoData) {
        const tablesarr = this.props.dataConnector.xanoDataSourceTables.map(
          ({ id, name, description, guid, auth }) => ({ id, name, description, guid, auth }),
        );
        const modifiedObject = {
          name: this.state.selectedOption.label,
          id: this.state.selectedOption.value,
        };
        console.log(modifiedObject);
        const dataForSave = {
          name: xanoCustomName,
          projectId,
          type: XANO,
          setting: {
            xanoApiAccessToken: token,
            xanoBaseUrl: 'https://x8ki-letl-twmt.n7.xano.io/api:meta/workspace/',
          },
          completeData: {
            workspace: modifiedObject,
            tables: tablesarr,
          },
          projectVersion: version,
        };
        await actions.saveDataInExternalDb({ dataForSave, version, projectId });
        const { uuid } = this.props.dataConnector.xanoSavedData;
        if (uuid) {
          await actions.createEnvironmentVariables({
            dataForSave,
            version,
            projectId,
            externalDatabaseId: uuid,
          });
        }

        this.props.history.push(
          `/data-connector/${version}/v/${this.props.match.params.projectId}/xano-collections-list`,
          {
            token: token,
            allColname: this.props.dataConnector.xanoDataSourceTables,
            idwork: this.state.selectedOption,
            saveExData: this.props.dataConnector.xanoSavedData,
          },
        );
      }
    } catch (error) {
      console.error('API call error:', error);
    }
  };

  handleChange = (name, value) => {
    this.setState({ selectedOption: value });
  };

  handleSendRequset = () => {
    if (this.state.selectedOption) {
      this.handleApi(this.state.selectedOption.value);
    } else {
      this.setState({ selectError: 'Select DataBase !' });
    }
  };

  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />
        </CommonPageComponent>
      );
    }
    const {
      getXanoTablePending,
      getXanoApiGroupsPending,
      xanoTokenUrlPending,
      getXanoInstancePending,
    } = this.props.dataConnector;
    const { xanoData } = this.props.location.state;
    const dropdown = xanoData.map((item, index) => ({
      label: item.name,
      value: item.id,
    }));

    if (getXanoApiGroupsPending || xanoTokenUrlPending || getXanoInstancePending) {
      return (
        <CommonPageComponent>
          <div className="text-center">
            <CustomLoader
              loading={getXanoApiGroupsPending || xanoTokenUrlPending || getXanoInstancePending}
              size="20px"
              color="#303453"
            />
          </div>
        </CommonPageComponent>
      );
    }
    return (
      <CommonPageComponent>
        <ParentContentCard title="Choose Database for Creating Collection" icon="collection">
          <Formik initialValues={{}}>
            {({ values, handleChange, setFieldValue }) => (
              <Form className="form-row">
                <div className="container">
                  <div className="row justify-content-center">
                    <div className="col-md-6">
                      <div className="text-center mb-3">
                        <CustomSelect
                          name="selectedDatabase"
                          isMulti={false}
                          isObject={true}
                          options={dropdown}
                          onBlur={() => {}}
                          value={this.state.selectedDatabase}
                          placeholder="Select Database"
                          onChange={this.handleChange}
                        />
                        {this.state.selectError && (
                          <p className="text-danger">{this.state.selectError}</p>
                        )}
                      </div>
                      <div className="text-right">
                        <button
                          className="btn btn-theme-submit"
                          onClick={this.handleSendRequset}
                          disabled={getXanoTablePending}
                        >
                          <i className="wb webconnect-rocket"></i>
                          &nbsp;Continue&nbsp;
                          <CustomLoader loading={getXanoTablePending}></CustomLoader>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(XanoDatabaseList);
